<router-outlet />
@if (loader.active()) {
  <app-loader mode="fullscreen" [size]="48" />
}
